import SharedHeader from '@/components/share/header'
import SharedFooter from '@/components/share/footer'
import SharedSidebar from '@/components/share/sidebar'
import DoughnutChart from '@/components/share/DoughnutChartSwipe'
import DoughnutChartQuestion from '@/components/share/DoughnutChartQuestion'
import HorizontalBarChart from '@/components/share/HorizontalBarChart'
import * as palette from 'google-palette'

export default {
  name: 'swipeDetail',
  components: {
    SharedHeader,
    SharedFooter,
    SharedSidebar,
    DoughnutChart,
    DoughnutChartQuestion,
    HorizontalBarChart
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    api () {
      return this.$store.getters.api
    },
    env () {
      return this.$store.getters.env
    },
    avatar () {
      return this.$store.getters.avatar
    }
  },
  data () {
    return {
      sidebar_tab: '9',
      loading: true,
      selecting: false,
      theme: {},
      category: [
        {
          name: '会社情報',
          icon: ['fas', 'building'],
          description: ''
        },
        {
          name: '社員情報',
          icon: ['fas', 'portrait'],
          description: ''
        },
        {
          name: '職場情報',
          icon: ['fas', 'map-marker-alt'],
          description: ''
        },
        {
          name: '新卒採用情報',
          icon: ['fas', 'user-tie'],
          description: ''
        },
        {
          name: 'インターン採用情報',
          icon: ['fas', 'school'],
          description: ''
        },
        {
          name: 'イベント情報',
          icon: ['fas', 'bullhorn'],
          description: ''
        },
        {
          name: 'リリース情報',
          icon: ['fas', 'info-circle'],
          description: ''
        },
        {
          name: '記事情報',
          icon: ['fas', 'rss-square'],
          description: ''
        },
        {
          name: 'アルバイト採用情報',
          icon: ['fas', 'coffee'],
          description: ''
        }
      ],
      updating: false,
      card: {title: ''},
      doughnutData: [0, 100],
      trash: {
        doughnutData: [],
        colors: [],
        labels: [],
        total: 0
      },
      manageList: [],
      selected: '',
      result: {},
      qeustion: {},
      analytics: {
        like: {},
        trash: {},
        isOpen: false,
        loading: true,
        tabLike: 0,
        tabTrash: 0
      }
    }
  },
  mounted () {
    this.loading = true
    this.fetchData()
  },
  methods: {
    fetchData () {
      let pathParams = {
        swipeId: this.$route.params.swipeId
      }

      let additionalParams = {
        queryParams: {
          type: 'detail'
        }
      }

      this.$apig.get(this.api.SWIPE, pathParams, additionalParams, {})
        .then(response => {
          this.card = response.data.swipeCard
          this.result = response.data.result
          this.question = response.data.question
          this.theme = response.data.theme
          this.manageList = response.data.manageList
          this.select(response.data.manageList[0].manageId)

          this.loading = false
        })
        .catch(err => {
          console.log(err)
        })
    },
    select (manageId) {
      this.selecting = true
      this.selected = manageId
      this.doughnutData = [this.result[manageId].like, this.result[manageId].trash]

      if (this.card.questionnaire) {
        this.trash.doughnutData = []
        this.trash.labels = []
        this.trash.total = 0

        for (let key in this.question[manageId]) {
          this.trash.doughnutData.push(this.question[manageId][key].cnt)
          this.trash.labels.push(this.question[manageId][key].label)
          this.trash.total += this.question[manageId][key].cnt
        }

        let colors = []
        colors = palette('mpn65', this.trash.doughnutData.length)
        if (colors) {
          colors = colors.map((hex) => {
            return '#' + hex
          })
        }

        this.trash.colors = colors
      }

      setTimeout(() => {
        this.selecting = false
      }, 300)
    },
    getCover (coverStatus, id) {
      if (!coverStatus) {
        return id
      } else if (coverStatus === 1) {
        return `${this.env.S3}/enterprise/swipe/${id}.png`
      }
    },
    fetchDetail () {
      this.analytics.loading = true
      this.analytics.isOpen = true

      let pathParams = {
        swipeId: this.$route.params.swipeId
      }

      let additionalParams = {
        queryParams: {
          type: 'analytics',
          manageId: this.selected
        }
      }

      this.$apig.get(this.api.SWIPE, pathParams, additionalParams, {})
        .then(response => {
          this.analytics.like = response.data.like
          this.analytics.trash = response.data.trash

          let colors = []

          colors = palette('mpn65', Object.keys(this.analytics.like).length)
          if (colors) {
            colors = colors.map((hex) => {
              return '#' + hex + '90'
            })
          }

          let cnt = 0
          for (let key in this.analytics.like) {
            this.analytics.like[key].colors = colors[cnt]
            cnt++
          }

          colors = []

          colors = palette('mpn65', Object.keys(this.analytics.trash).length)
          if (colors) {
            colors = colors.map((hex) => {
              return '#' + hex + '90'
            })
          }

          cnt = 0
          for (let key in this.analytics.trash) {
            this.analytics.trash[key].colors = colors[cnt]
            cnt++
          }

          this.analytics.loading = false
        })
        .catch(err => {
          console.log(err)
        })
    },
    getTitle (key) {
      switch (key) {
        case 'job':
          return '希望職種'
        case 'school':
          return '学校'
        case 'graduateYear':
          return '卒業年'
        case 'study':
          return '学んでいる学問'
      }
    },
    getKey (i) {
      switch (i) {
        case 0:
          return 'job'
        case 1:
          return 'study'
        case 2:
          return 'school'
        case 3:
          return 'graduateYear'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/swipe/detail/detail.js